import React, { useState, useEffect } from "react";
import api from "../../api/api";
import dayjs from "dayjs";
import ToastMessage from "../../utils/mui/righttoptoast";
import { getPracticeId } from "../../config/practice";

const VisitStatus = ({ fetchScheduleData, setIsAptcard, setScreen, selectedAppointment,selectedDate,closeAllModals }) => {
  const [activeButton, setActiveButton] = useState(null); // Store the selected status
  const [statusOptions, setStatusOptions] = useState([]); // State to hold fetched status options
  const [loading, setLoading] = useState(false); // State for loading indicator
  const practiseid = getPracticeId();
  const [SelectedVisit,setSelectedVisit]=useState('')
     const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
      const [toastSeverity, setToastSeverity] = useState('success');
  const fetchStatusData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.post(`/v1/${practiseid}/appointments/status-types`,{
        "appointment_types": [
            "check-in",
            "visit confirmation"
        ]
    });
      if (response.status === 200) {
        setStatusOptions(response.data); 
      } else {
        setStatusOptions([]); // Clear if response is not successful
      }
    } catch (error) {
      console.error(error);
      setStatusOptions([]); // In case of error, clear the options
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Fetch status data when component mounts
  useEffect(() => {
    fetchStatusData();
  }, []);

  const handleToastClose = () => {
    setOpenToast(false)
};

  const SelectDate = new Date(selectedAppointment.startdate);
  const formattedDate = SelectDate.getFullYear() + '-' 
                       + (SelectDate.getMonth() + 1).toString().padStart(2, '0') + '-'
                       + SelectDate.getDate().toString().padStart(2, '0');
  
  console.log(formattedDate);

  const UpdateVisitStatus = async ({selectedvisit}) => {
    if (!selectedvisit) return; // Prevent update if no status is selected

    try {
      const response = await api.put(`/v1/${practiseid}/appointments/visit-purpose/update`, {
        "itemVal": [selectedvisit], // Pass the selected status value
        "dtype": ['dtvisit'],
        "app_id": [selectedAppointment.appointmentid],
        "cid": [selectedAppointment.AID],
        "searchdate": formattedDate
      });

      if (response.status === 200) {
        fetchScheduleData(selectedDate);
        setToastMessage(" Visit Status Updated successfully");
        setToastSeverity('success');
        setOpenToast(true);

         setTimeout(() => {
  setIsAptcard(false);
}, 1500);
      } else {
        console.error("Update failed.");
        setToastMessage('Failed to Update Visit Status. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      setToastMessage('Something Went Wrong');
      setToastSeverity('error');
      setOpenToast(true);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col gap-4 lg:w-[30%] w-[60%] bg-white rounded-lg shadow-lg text-left">
        <div>
          <div className="w-full flex items-center justify-between mt-2 p-2 px-4">
            {/* Close Button */}
            <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
              Visit Status
            </span>
            <button
              className="text-gray-500 hover:text-gray-700 text-[30px]"
              onClick={()=>{
                setScreen(0)
              }}
            >
              &times;
            </button>
          </div>
          <div className="h-px bg-[#D0D5DD]"></div>
        </div>

        {/* Status Buttons */}
        <div className="flex flex-wrap gap-4 p-4">
          {loading ? (
            <div>Loading...</div> // Show loading message or spinner while fetching data
          ) : (
            statusOptions.map((status, index) => (
              <button
                key={index}
                className={`rounded-full py-2 px-3 font-inter text-[12px] shadow-md border-[1.5px] border-gray-200 truncate ${
                  activeButton === status.value ? "bg-[#E17954] text-white" : "bg-[#F3F3F3] text-[#374151]"
                }`}
                onClick={() => {
                  setActiveButton(status.value);
                  setSelectedVisit(status.value)
                }} // Set the selected status directly
            
              >
                {status.value}
              </button>
            ))
          )}
        </div>

        {/* Update Button */}
        <div className="w-full flex justify-center mt-2 py-4 border-t bg-[#F9FAFB] rounded">
          <button 
            onClick={() => UpdateVisitStatus({selectedvisit:SelectedVisit})} 
            className="rounded py-2 px-4 w-[90%] font-inter transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[black] text-[#FFFFFF]"
          >
            Update
          </button>
        </div>
      </div>
      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default VisitStatus;
